/**
 * Permanent (301) redirects for blog articles that have been consolidated.
 *
 * When two or more articles were genuinely competing for the same search
 * intent, their content was merged into one authoritative pillar article and
 * the weaker URLs now point at the surviving one. Keeping the redirect (rather
 * than deleting the page) preserves any links, bookmarks and ranking history
 * pointing at the old address.
 *
 * Never remove an entry: an old URL must keep resolving forever.
 */
export const BLOG_SLUG_REDIRECTS: Record<string, string> = {
  // Trauma bond cluster — merged 20 Sep 2026 into the pillar that was the only
  // one of the four with measurable Google visibility.
  "what-is-a-trauma-bond-signs-stages-break-free": "trauma-bonding-explained",
  "signs-of-a-trauma-bond-checklist": "trauma-bonding-explained",

  // Nervous system regulation — two near-identical guides merged 20 Sep 2026.
  "how-to-regulate-your-nervous-system-guide": "how-to-regulate-your-nervous-system-after-trauma",
};

export function blogRedirectTarget(slug: string): string | undefined {
  return BLOG_SLUG_REDIRECTS[slug];
}
